import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Center } from "@pdfking/math"
import { HALF_TURN } from "@pdfking/math/constants"

import type { ImpositionPage } from "#internal"

/** The page as it is authored — its own width and height — centred where it
 * landed: what a shape that carries the page's turn is written on, so the turn
 * brings it onto the page's footprint. */
export const OwnBox = ({ position, rotation }: ImpositionPage): SpatialRectangle<Distance> => {
  if (!(rotation % HALF_TURN)) return position
  const { x, y } = Center(position)
  return {
    x: (x - position.height / 2) as Distance,
    y: (y - position.width / 2) as Distance,
    width: position.height,
    height: position.width,
  }
}
